
import { useEffect, useState, } from "react";
import api from '../../services/api';
import { InputBase, Button } from "@mui/material";
import HeaderSession from "../../utils/headerSession";
import ListaExpediente from "./listaExpediente";
import ExpedienteForm from "../../pages/expediente/expedienteForm";


export default function EntradaExpediente() {
    const [entradas, setEntradas] = useState('')
    // const [configLista, setConfigLista] = useState('')
    const [page, setPage] = useState('')
    const [openForm, setOpenForm] = useState(false)
    const [filter, setFilter] = useState('')
    const [status, setStatus] = useState('Análise')

    useEffect(() => {
              api.get(`/expedientes?status=${status}&page=${page}`)
            .then(response => {
                // console.log(response)
                setEntradas(response.data.expedientes);
                setFilter(response.data.expedientes);
                // setConfigLista(response.data);
            }).catch(err => '')
    }, [page, status, openForm])

    const filtraentradas = (valor) => {
        setEntradas(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
    }

    return (
        <div>
            <HeaderSession title={'EXPEDIENTE / ENTRADAS'} />

            <div style={{ display: 'flex', marginBottom: 20 }}>

                <Button
                    variant="contained"
                    style={{ background: '#85287e', marginRight: 20 }}
                    onClick={() => setOpenForm(!openForm)}
                >
                    Nova Entrada
                </Button>

                {/* FORMULARIO PARA CRIAR EXPEDIENTE */}
                <ExpedienteForm open={openForm} />

                <InputBase
                    style={{ width: '70%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                    sx={{ ml: 1, flex: 1 }}
                    autoFocus
                    placeholder="Filtro"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { filtraentradas(e.target.value) }}
                />

                {/* <TextField
                        style={{ width: 200 }}
                        type="text"
                        label="Estado"
                        select
                        size="small"
                        variant="outlined"
                        onChange={(e) => { setStatus(e.target.value) }}
                        defaultValue={'Análise'}
                    >
                        <MenuItem key='Análise' value='Análise'> Análise </MenuItem>
                        <MenuItem key='Concluído' value='Concluído'> Já respondidos </MenuItem>

                    </TextField> */}
            </div>

            <ListaExpediente
                expedientes={entradas}
                setPage={setPage}
            />

        </div>
    )
}
